// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3I9_Y","inputWrap":"CustomTip_inputWrap__2aq-v"};